import { STYLE_OPTIONS } from 'src/constants';

const searchBoxStyle = () => ({
  buttonAdd: {
    ...STYLE_OPTIONS.BUTTON_PRIMARY,
    boxShadow: 'none',

    '& .MuiSvgIcon-root': {
      marginRight: 14,
    },
  },
});

export default searchBoxStyle;
